'use strict';

/* eslint no-undef: "off" */
/**
 * XPark hero banner
 */
define('xparkHeroBanner',['swiper', 'xparkHomepageApi', 'appStorage', 'GAReport'], function (Swiper, xparkHomepageApi, appStorage, GAReport) {
  return {
    template: '\n      <section class="xp-hero-banner" :class="sortCode" v-if="bannerList.length">\n        <div v-if="loading" class="skeleton-loading"></div>\n        <div v-if="bannerList.length" class="xp-hero-banner-swiper swiper-container" ref="heroBannerSwiper">\n          <div class="swiper-wrapper">\n            <a\n              v-for="(item, index) in bannerList"\n              :key="item.image + index"\n              class="xp-hero-banner-slide swiper-slide"\n              :href="item.url"\n              aria-label="View banner"\n              @click="handelGA(item)"\n            >\n              <img :src="item.image" alt="" />\n            </a>\n          </div>\n          <div class="xp-hero-banner-pagination swiper-pagination"></div>\n        </div>\n      </section>\n    ',
    data: function data() {
      return {
        heroBannerSlider: null,
        heroBannerTimer: null,
        bannerList: [],
        loading: false
      };
    },
    created: function created() {
      var data = appStorage.get("bannerList_" + this.sortCode);
      if (data) {
        this.bannerList = JSON.parse(data);
      }
    },

    props: {
      sortCode: {
        type: String,
        default: ''
      }
    },
    mounted: function mounted() {
      this.fetchHeroBanner();
    },
    beforeDestroy: function beforeDestroy() {
      if (this.heroBannerTimer) {
        window.clearTimeout(this.heroBannerTimer);
      }

      if (this.heroBannerSlider && this.heroBannerSlider.destroy) {
        this.heroBannerSlider.destroy(true, true);
      }
    },

    methods: {
      fetchHeroBanner: function fetchHeroBanner() {
        var _this = this;

        this.loading = true;
        xparkHomepageApi.getHeroBanner({
          banner: this.getBannerIndex()
        }).then(function (data) {
          var list = _this.normalizeBannerList(data);

          if (!list.length) {
            return;
          }

          _this.bannerList = list;
          _this.$nextTick(_this.resetHeroBannerSlider);
          appStorage.set("bannerList_" + _this.sortCode, JSON.stringify(list));
          _this.reportGAPromotionView(_this.bannerList);
        }).catch(function () {}).finally(function () {
          return _this.loading = false;
        });
      },
      getBannerIndex: function getBannerIndex() {
        var match = String(this.sortCode || '').match(/^banner_(\d+)$/);

        return match ? Number(match[1]) : 1;
      },
      normalizeBannerList: function normalizeBannerList(data) {
        var source = Array.isArray(data) ? data : data && (data.banner_list || data.banners || data.list || data.items) || [];

        if (!Array.isArray(source)) {
          return [];
        }

        return source.map(function (item) {
          return {
            image: item.image || item.image_url || item.banner_image || item.mobile_image || item.cover_image || '',
            url: item.url || item.link_url || item.redirect_url || item.link || 'javascript:void(0);',
            name: item.name,
            id: item.name
          };
        }).filter(function (item) {
          return item.image;
        });
      },
      resetHeroBannerSlider: function resetHeroBannerSlider() {
        if (this.heroBannerTimer) {
          window.clearTimeout(this.heroBannerTimer);
          this.heroBannerTimer = null;
        }

        if (this.heroBannerSlider && this.heroBannerSlider.destroy) {
          this.heroBannerSlider.destroy(true, true);
          this.heroBannerSlider = null;
        }

        this.initHeroBannerSlider();
      },
      initHeroBannerSlider: function initHeroBannerSlider() {
        var _this2 = this;

        var container = this.$refs.heroBannerSwiper;

        if (!container || !this.bannerList.length) {
          return;
        }

        this.heroBannerTimer = window.setTimeout(function () {
          _this2.heroBannerSlider = new Swiper(container, {
            autoplay: {
              delay: 5000,
              disableOnInteraction: false
            },
            loop: _this2.bannerList.length > 1,
            loopAdditionalSlides: _this2.bannerList.length,
            loopedSlides: _this2.bannerList.length,
            observer: true,
            observeParents: true,
            pagination: {
              el: '.xp-hero-banner-pagination',
              clickable: true
            },
            slidesPerView: 1,
            speed: 350
          });
        }, 20);
      },
      reportGAPromotionView: function reportGAPromotionView(list) {
        var promotions = [];
        (list || []).map(function (item, index) {
          if (!item.id || !item.alt) {
            return;
          }
          promotions.push({
            'id': item.id || "",
            'name': item.alt || item.creative || "",
            'creative': item.creative || "",
            'position': index + 1,
            'url': item.url
          });
        });

        new GAReport().promotionView({
          'eventAction': 'HOME_BANNER_' + item.name,
          'eventCategory': 'HOME_BANNER_#VERSION#_TOP',
          'promotions': promotions
        });
      },
      handelGA: function handelGA(item) {
        new GAReport().promotionClick({
          'eventAction': 'HOME_BANNER_' + item.name,
          'eventCategory': 'HOME_BANNER_#VERSION#_TOP',
          'promotions': [item]
        });
      }
    }
  };
});
